import config from '@plone/volto/registry';
import { addStyling } from '@plone/volto/helpers/Extensions/withBlockSchemaEnhancer';
import { accordionMessages as messages } from '../../../../../../../customization-messages';

export const AccordionSchema = (intl) => {
  return {
    title: intl.formatMessage(messages.Accordion),
    fieldsets: [
      {
        id: 'default',
        title: intl.formatMessage(messages.Default),
        fields: ['panel_title'],
      },
    ],
    properties: {
      panel_title: {
        title: intl.formatMessage(messages.AccordionTitle),
      },
    },
    required: [],
  };
};

export const AccordionBlockSchema = ({ intl }) => ({
  title: intl.formatMessage(messages.AccordionBlock),
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage(messages.Default),
      fields: ['data'],
    },
    {
      id: 'options',
      title: intl.formatMessage(messages.Options),
      fields: [
        'left_arrows',
        'openOnStart',
        'exclusive',
        // 'groups'
      ],
    },
  ],
  properties: {
    data: {
      title: intl.formatMessage(messages.Accordion),
      type: 'panels',
      schema: AccordionSchema(intl),
    },
    left_arrows: {
      title: intl.formatMessage(messages.left_arrows),
      description: intl.formatMessage(messages.left_arrows_description),
      type: 'boolean',
      default: false,
    },
    openOnStart: {
      title: intl.formatMessage(messages.openOnStart),
      type: 'boolean',
      default: false,
    },
    exclusive: {
      title: intl.formatMessage(messages.exclusive),
      // description: intl.formatMessage(messages.exclusive_description),
      type: 'boolean',
      default: false,
    },
    // groups: {
    //   title: intl.formatMessage(messages.groups),
    //   description: intl.formatMessage(messages.groups_description),
    //   type: 'boolean',
    //   default: false,
    // },
  },
  required: [],
});

export const AccordionStylingSchema = (props) => {
  const { intl } = props;
  const schema = addStyling(props);
  schema.properties.styles.schema = {
    title: intl.formatMessage(messages.Accordion),
    block: 'accordion',
    fieldsets: [
      {
        id: 'default',
        title: intl.formatMessage(messages.Default),
        fields: ['theme'],
      },
    ],
    properties: {
      theme: {
        title: intl.formatMessage(messages.Theme),
        description: intl.formatMessage(messages.ThemeHelp),
        widget: 'theme_picker',
        colors: [
          ...(config.settings && config.settings.themeColors
            ? config.settings.themeColors.map(({ value, title }) => ({
                name: value,
                label: title,
              }))
            : []),
        ],
      },
    },
    required: [],
  };
  return schema;
};
